import preact, { Component, h } from 'preact'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'
import axios from 'axios'

interface Props {
  webmaster: Array<string>,
  emails: Array<string>,
  name: string
}

interface State {
  email: string,
  name: string,
  loading: boolean
}

interface WebmasterComponentProps extends Props {
  loading: boolean,
  onChangeMail: (val: string) => void,
  onChangeName: (val: string) => void,
  setWebmaster: (val: string) => void
}

class WebmasterSetup extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      email: props.webmaster.length > 0 ? props.webmaster[0] : '',
      name: props.name,
      loading: false
    }
  }

  async setWebmaster () {
    this.setState({ loading: true })
    try {
      await axios.post('/settings/emailManagement/saveWebmaster', {
        email: this.state.email,
        name: this.state.name
      })
      this.setState({ loading: false })
      window.location.reload()
    } catch (e) {
      this.setState({ loading: false })
      console.log('e ', e)
    }
  }

  render (props: Props, state: State) {
    return props.emails.length > 0 ? <WebmasterComponent
      {...props}
      {...state}
      onChangeMail={(val: string) => this.setState({ email: val })}
      onChangeName={(val: string) => this.setState({ name: val })}
      setWebmaster={() => this.setWebmaster()}
    /> : null
  }
}

const WebmasterComponent = (props: WebmasterComponentProps) => <div class='email-setup'>
  <h3>Email Setup</h3>

  <div class='form'>
    <div class='row'>
      <label for='webmaster'>Webmaster Email:</label>
      <InputGroup
        type='text'
        placeholder='eg: Insided Community'
        value={props.name}
        onChange={(e: {target: HTMLInputElement}) => props.onChangeName(e.target.value)} />
      <select
        class='webmasterSelector'
        onChange={(e: preact.ChangeEvent<HTMLSelectElement>) => props.onChangeMail(e.target.value)}>
        <option disabled selected={props.webmaster.length === 0}>Select your option</option>
        { props.emails.map(email => <option selected={props.webmaster.length > 0 && email === props.webmaster[0]}>{email}</option>) }
      </select>
      <ButtonControl variant='success' title='Save' isLoading={props.loading} onClick={props.setWebmaster} />
    </div>
  </div>
</div>

export { WebmasterComponent }
export default WebmasterSetup
